import Viola51 from '../../../media/SCG/Viola/5/Viola 5.webp'
import Viola52 from '../../../media/SCG/Viola/5/5 Deluxe.png'
import Viola53 from '../../../media/SCG/Viola/5/5 Premium.png'
import Viola54 from '../../../media/SCG/Viola/5/5 Attic.png'

const Viola5images =[
Viola51,Viola52,Viola53,Viola54
]

export default Viola5images;